import { format as dateFnsFormat } from 'date-fns';
import { formatInTimeZone, toDate } from 'date-fns-tz';
import { DEFAULT_DATE_TIME_FORMAT } from './types';
export function formatDateTime(date, options) {
  if (date == undefined) {
    return '';
  }

  var {
    format = DEFAULT_DATE_TIME_FORMAT,
    timeZone
  } = options !== null && options !== void 0 ? options : {};

  var _date = toDate(date); // format in local time zone


  if (!timeZone) {
    return dateFnsFormat(_date, format);
  }

  return formatInTimeZone(_date, timeZone, format);
}
//# sourceMappingURL=formatDateTime.js.map